import { combineReducers } from "@reduxjs/toolkit"
import tokenSlice from "./features/tokenSlice"
import playerSlice from "./features/playerSlice"
import awardsSlice from "./features/awardsSlice"
import playerPageSlice from "./features/playerPageSlice"
import teamSlice from "./features/teamSlice"

const reducers = combineReducers({
    token: tokenSlice,
    player: playerSlice,
    playerPage: playerPageSlice,
    awards: awardsSlice,
    team: teamSlice
})

export default reducers